const PREVIEW_ONLY_EXTENSIONS = new Set([
  'pdf',
  'jpg',
  'jpeg',
  'png',
  'gif',
  'webp',
  'bmp',
  'tif',
  'tiff',
]);

function normalizeExtension(input?: string | null): string {
  const raw = String(input || '').trim().toLowerCase();
  if (!raw) return '';
  return raw.startsWith('.') ? raw.slice(1) : raw;
}

function getExtensionFromFileName(fileName?: string | null): string {
  const name = String(fileName || '').trim();
  if (!name.includes('.')) return '';
  const ext = name.split('.').pop();
  return normalizeExtension(ext || '');
}

export function isPreviewOnlyDocument(args: {
  fileName?: string | null;
  fileExtension?: string | null;
  mimeType?: string | null;
}): boolean {
  const ext = normalizeExtension(args.fileExtension) || getExtensionFromFileName(args.fileName);
  if (ext && PREVIEW_ONLY_EXTENSIONS.has(ext)) return true;

  const mime = String(args.mimeType || '').toLowerCase();
  if (mime === 'application/pdf') return true;
  if (mime.startsWith('image/')) return true;

  return false;
}

export function canPreviewDocument(args: {
  fileName?: string | null;
  fileExtension?: string | null;
  mimeType?: string | null;
}): boolean {
  return isPreviewOnlyDocument(args);
}

export function canDownloadDocument(args: {
  fileName?: string | null;
  fileExtension?: string | null;
  mimeType?: string | null;
}): boolean {
  // Download is enabled for every file type, including preview-capable
  // PDF/images. Permission checks (confidential, restricted) still apply
  // at the call sites.
  return true;
}
